import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";

const ReportsStatCard = ({ title, value, icon, color = "primary.main", isRTL }) => (
  <Card
    dir={isRTL ? "rtl" : "ltr"}
    sx={{
      height: "100%",
      borderRadius: 2,
      boxShadow: 1,
      textAlign: "start",
    }}
  >
    <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ color, fontSize: 28, mx: 1.5, display: "flex", flexShrink: 0 }}>
          {icon}
        </Box>
        <Box sx={{ px: 1, minWidth: 0, flex: 1, textAlign: "start" }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "0.85rem", mb: 0.5, textAlign: "start" }}
            noWrap
          >
            {title}
          </Typography>
          <Typography
            variant="h5"
            component="div"
            sx={{ fontWeight: "bold", textAlign: "start" }}
          >
            {value ?? 0}
          </Typography>
        </Box>
      </Box>
    </CardContent>
  </Card>
);

export default ReportsStatCard;
